import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Card, CardContent,
  CardsContainer,
  Container, Description,
  Header, IconContainer, Title
} from "@/components/organism/TailoredFeaturesSection/TailoredFeaturesSection.styles";

const texts = {
  performanceAnalysisLabel: 'getStartedPage.common.performanceAnalysis.label',
  performanceAnalysisDescription: 'getStartedPage.common.performanceAnalysis.description',
  manTrainingLabel: 'getStartedPage.common.manTraining.label',
  manTrainingDescription: 'getStartedPage.common.manTraining.description',
  tailoredFeaturesLabel: 'getStartedPage.featuresSection.tailoredFeatures.label',
  tailoredFeaturesSubLabel: 'getStartedPage.featuresSection.tailoredFeatures.sub.label',
};

const cards = [
  {
    title: texts.performanceAnalysisLabel,
    iconClass: 'rioglyph-stats',
    description: texts.performanceAnalysisDescription,
  },
  {
    title: texts.manTrainingLabel,
    iconClass: 'rioglyph-book',
    description: texts.manTrainingDescription,
  },
];

const TailoredFeaturesSection = React.forwardRef<HTMLDivElement>((_props, ref) => (
  <Container ref={ref}>
    <Header>
      <h2>
        <FormattedMessage id={texts.tailoredFeaturesLabel} />
      </h2>
      <h3>
        <span>
          <FormattedMessage id={texts.tailoredFeaturesSubLabel} />
        </span>
      </h3>
    </Header>
    <CardsContainer>
      {cards.map((card, index) => (
        <Card key={index}>
          <CardContent>
            <IconContainer>
              <span className={`rioglyph ${card.iconClass}`} />
            </IconContainer>
            <Title>
              <FormattedMessage id={card.title} />
            </Title>
            <Description>
              <FormattedMessage id={card.description} />
            </Description>
          </CardContent>
        </Card>
      ))}
    </CardsContainer>
  </Container>
));

export default TailoredFeaturesSection;
